import * as React from 'react';
import { throttle } from 'throttle-debounce';

interface IUseFixedHeaderParams {
  ref: React.RefObject<HTMLDivElement> | null;
}

export const useFixedHeader = ({ ref }: IUseFixedHeaderParams) => {
  const [isFixedHeaderShown, setIsFixedHeaderShown] = React.useState(false);

  const isInViewport = React.useMemo(
    () =>
      throttle(100, () => {
        const searchBlock = ref?.current;

        if (!searchBlock) {
          return;
        }

        const bottom = searchBlock.getBoundingClientRect().bottom;

        setIsFixedHeaderShown(bottom <= 0);
      }),
    [ref],
  );

  React.useEffect(() => {
    document.addEventListener('scroll', isInViewport);

    return () => {
      document.removeEventListener('scroll', isInViewport);
    };
  }, [isInViewport]);

  return isFixedHeaderShown;
};
